export class CluWCashDeskMLoyaltyLandingClientItem {
    LC_CODE_INSCRIPTION : string;
    LC_CIVILITE : number = 0;
    LC_NOM : string = '';
    LC_PRENOM : string = '';
    LC_DATENAISSANCE : Date;
    LC_EMAIL : string = '';
    LC_TELEPHONE : string = '';
    LC_ADRESSE : string = '';
    LC_COMPLEMENT : string = '';
    LC_CODEPOSTAL : string = '';
    LC_REGION : string = '';
    LC_VILLE : string = '';
    LC_PAYS : string = '';
    LC_PAYS_LIB : string = '';
    LC_PAYS_INDICATIF : string = '';
}

export class CluWCashDeskLoyaltLandingClientInscriptionResult {
    NUMERO_CLIENT : string = '';
}